const PROBE_BYTES = 256 * 1024;

export function formatBytes(n) {
  if (!n || n < 0) return '';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let i = 0;
  let v = n;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i += 1;
  }
  return `${v.toFixed(v < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}

function detectFaststart(buffer) {
  const view = new DataView(buffer);
  if (view.byteLength < 16) return null;
  let offset = 0;
  while (offset + 8 <= view.byteLength) {
    let size = view.getUint32(offset);
    const type = String.fromCharCode(
      view.getUint8(offset + 4),
      view.getUint8(offset + 5),
      view.getUint8(offset + 6),
      view.getUint8(offset + 7),
    );
    if (size === 1) {
      if (offset + 16 > view.byteLength) return null;
      const hi = view.getUint32(offset + 8);
      const lo = view.getUint32(offset + 12);
      size = hi * (2 ** 32) + lo;
    } else if (size === 0) {
      if (type === 'moov') return true;
      if (type === 'mdat') return false;
      return null;
    }
    if (type === 'moov') return true;
    if (type === 'mdat') return false;
    if (size < 8) return null;
    offset += size;
  }
  return false;
}

export async function probeVideo(url, signal) {
  const result = {
    available: false,
    sizeBytes: null,
    contentType: null,
    acceptRanges: false,
    faststart: null,
    error: null,
  };

  try {
    let head = null;
    try {
      head = await fetch(url, { method: 'HEAD', signal });
    } catch {
      // HEAD often CORS-blocked or 403 on signed URLs — fall through to GET range
    }
    if (head?.ok) {
      const len = head.headers.get('content-length');
      if (len) result.sizeBytes = parseInt(len, 10);
      result.contentType = head.headers.get('content-type');
      result.acceptRanges = (head.headers.get('accept-ranges') || '').toLowerCase() === 'bytes';
      result.available = true;
    }

    const probe = await fetch(url, {
      headers: { Range: `bytes=0-${PROBE_BYTES - 1}` },
      signal,
    });
    if (!probe.ok && probe.status !== 206) {
      result.error = `HTTP ${probe.status}`;
      return result;
    }
    if (probe.status === 206) result.acceptRanges = true;
    if (!result.sizeBytes) {
      const m = (probe.headers.get('content-range') || '').match(/\/(\d+)$/);
      if (m) result.sizeBytes = parseInt(m[1], 10);
    }
    if (!result.contentType) result.contentType = probe.headers.get('content-type');
    result.faststart = detectFaststart(await probe.arrayBuffer());
    result.available = true;
    return result;
  } catch (e) {
    if (e.name === 'AbortError') throw e;
    result.error = e.message;
    return result;
  }
}
